import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=a95e2c7c&scoped=true&"
import script from "./newsDetail.vue?vue&type=script&lang=js&"
export * from "./newsDetail.vue?vue&type=script&lang=js&"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=a95e2c7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a95e2c7c",
  null
  
)

export default component.exports